import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex justify-content-between summary-times-container pt-0",
  style: {"padding-bottom":"10px"}
}


import { convertSecondsFromStringTime } from "@/services/functions";
import HeaderRow from "@/components/MonthlyReportWorkingTimesSettingParts/SummaryTableParts/HeaderRow";
import SummaryRow from "@/components/MonthlyReportWorkingTimesSettingParts/SummaryTableParts/SummaryRow";

import SubHeaderRow from "@/components/MonthlyReportWorkingTimesSettingParts/SubSummaryTableParts/HeaderRow";
import SubSummaryRow from "@/components/MonthlyReportWorkingTimesSettingParts/SubSummaryTableParts/SummaryRow";
type Props = {
  detailDataRef: any;
  restraintTime?: string;
  workingTime?: string;
  mileage?: number;
  drivingTime?: string;
  breakTime?: string;
  loadingTime?: string;
  unloadingTime?: string;
  shippingTime?: string;
  waitTime?: string;
  othersTime?: string;
  restTime?: string;
  leavingDiffTime?: string;
  overTime?: string;
  midnightWorkingTime?: string;
  boundTimeByDays?: string;
  average?: string;
  boundTimeByHours?: string;
  workingDays?: number;
  alertSetting?: any;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'SummaryTimesTable',
  props: {
    detailDataRef: {},
    restraintTime: {},
    workingTime: {},
    mileage: {},
    drivingTime: {},
    breakTime: {},
    loadingTime: {},
    unloadingTime: {},
    shippingTime: {},
    waitTime: {},
    othersTime: {},
    restTime: {},
    leavingDiffTime: {},
    overTime: {},
    midnightWorkingTime: {},
    boundTimeByDays: {},
    average: {},
    boundTimeByHours: {},
    workingDays: {},
    alertSetting: {}
  },
  setup(__props: any) {

const props = __props;

const boundDayColor = () => {
  if (!props.workingDays || !props.boundTimeByDays) return "black";
  if (props.boundTimeByDays == "0") return "black";

  return Number(props.workingDays) > Number(props.boundTimeByDays)
    ? "red"
    : "black";
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("table", null, [
        _createVNode(_unref(HeaderRow)),
        _createVNode(_unref(SummaryRow), {
          detailDataRef: __props.detailDataRef,
          alertSetting: __props.alertSetting
        }, null, 8, ["detailDataRef", "alertSetting"])
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("table", null, [
        _createVNode(_unref(SubHeaderRow)),
        _createVNode(_unref(SubSummaryRow), {
          detailDataRef: __props.detailDataRef,
          boundTimeByHours: __props.boundTimeByHours,
          boundTimeByDays: props.boundTimeByDays
        }, null, 8, ["detailDataRef", "boundTimeByHours", "boundTimeByDays"])
      ])
    ])
  ]))
}
}

})